import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';

import NodeContext from '../providers/NodeProvider';

const Area = observer(({ node }) => {
  const { updateNode } = useContext(NodeContext);

  return (
    <div
      key={node.id}
      className='area'
      onClick={(e) => updateNode(e, node, 'horizontal')}
      onContextMenu={(e) => updateNode(e, node, 'vertical')}
    ></div>
  );
});

export default Area;
